import { BundlePriceProps } from './types';
import { useEffect, useState } from 'react';
import { formattingNumber } from '../../Helper/utils/utils';
import { StyledBundlePrice, StyledBundlePriceButton } from './style';

const design: Record<string, any> = {
  match: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  communix: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  bagelcode: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  me2on: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  locobingo: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  hug: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  ak: {
    width: {
      small: '90px',
      normal: '160px',
    },
  },
  mainSub: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  mainSubAlt: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  playSimple: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  pipa: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
};

const BundlePrice = ({
  price,
  height,
  whiteStripe = false,
  textShadow,
  borderRadius,
  type = 'ak',
  isPreview = false,
  availabilityText = 'Availability',
  availability = undefined,
  buttonText = 'Collect',
  isFree = false,
  width,
}: BundlePriceProps) => {
  const [finalPrice, setFinalPrice] = useState('');

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      !isPreview,
    );
    setFinalPrice(formattedPrice);
  }, [price]);

  return (
    <StyledBundlePriceButton
      height={height}
      width={width ?? design[type]?.width.normal}
      borderRadius={borderRadius}
      className="price"
    >
      {whiteStripe && <div className="white_stripe"></div>}
      <StyledBundlePrice
        direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
        marginRight={
          price.spacing && price.symbolPosition === 'Left' ? '4px' : '0px'
        }
        marginLeft={
          price.spacing && price.symbolPosition === 'Right' ? '4px' : '0px'
        }
        textShadow={textShadow}
      >
        <div className="totalPrice">
          {isFree ? (
            <span>{buttonText}</span>
          ) : (
            <>
              <span>{price.currencySymbol}</span>
              <span>{finalPrice}</span>
            </>
          )}
          {availabilityText && availability && (
            <span className="availability">
              {availabilityText} {availability.remaining} / {availability.total}
            </span>
          )}
        </div>
      </StyledBundlePrice>
    </StyledBundlePriceButton>
  );
};

export default BundlePrice;
